import React from "react";
import { ErrorBoundaryProps, ErrorBoundaryState } from "./types";
import Fallback from "./Fallback";
import * as Sentry from "@sentry/browser";
import authStore from "../../stores/AuthStore";

export default class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  componentDidCatch(error: Error, errorInfo: any) {
    console.error(error, errorInfo);

    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    Sentry.withScope((scope) => {
      scope.setExtras({
        errorInfo,
        url: window.location.href,
        userInfo: {
          id: authStore.user.id,
          email: authStore.user.email,
        },
      });
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  render() {
    if (this.state?.errorInfo) {
      return <Fallback />;
    }

    return this.props.children;
  }
}
